import React from 'react'

import { Product } from '../../types/product'

import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import {
  Box,
  Button,
  Stack,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import ProductItemInfo from './ProductItemInfo'

interface Props {
  isEven: boolean
  product: Product
}

const ProductItem = ({ product, isEven }: Props) => {
  const theme = useTheme()
  const isMatchDownMd = useMediaQuery(theme.breakpoints.down('md'))

  const [isOpen, setIsOpen] = React.useState(false)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <tr
        role="row"
        className="product-item"
        key={product.ProductCode}
        style={{
          backgroundColor: isEven
            ? alpha(theme?.palette?.primary?.main, 0.1)
            : '',
        }}
      >
        <td
          role="cell"
          data-label="Lender"
          style={{
            paddingTop: '30px',
            paddingBottom: '30px',
          }}
        >
          <img
            className="content"
            src={product.LenderImageUrl}
            alt={product.LenderName}
            style={{
              maxWidth: '100%',
              height: 'auto',
              maxHeight: '50px',
              objectFit: 'contain',
            }}
          />
        </td>
        <td role="cell" data-label="Initial Rate">
          <Typography
            variant="body1"
            component="span"
            className="content"
            fontSize={{
              md: '14px !important',
              xs: '12px !important',
            }}
          >
            <strong>{`${Number(product.InitialPayRate).toFixed(2)}`}%</strong>
            <br />
            then {product.StandardVariableRate}%
            <br />
            (variable)
          </Typography>
        </td>
        <td role="cell" data-label="Type and Duration">
          <Typography
            variant="body1"
            component="span"
            className="content"
            fontSize={{
              md: '14px !important',
              xs: '12px !important',
            }}
          >
            <strong>{product.MortgageClass}</strong>
            <br />
            for {product.InitialRateDuration} years
          </Typography>
        </td>
        {/*@ts-ignore*/}
        {theme?.custom?.appConfig?.showMonthlyPayment === 'Yes' ? (
          <td role="cell" data-label="Monthly Payment">
            <Typography
              variant="body1"
              component="span"
              className="content"
              fontSize={{
                md: '14px !important',
                xs: '12px !important',
              }}
            >
              <strong>£{product.InitialMonthlyPayment}</strong>
              <br />
              Initial
              <br />
              Monthly
              <br />
              Payment
            </Typography>
          </td>
        ) : null}
        <td role="cell" data-label="Max LTV">
          <Typography
            variant="body1"
            component="span"
            className="content"
            fontSize={{
              md: '14px !important',
              xs: '12px !important',
            }}
          >
            Max {product.MaxLTVAvailable}% LTV
          </Typography>
        </td>
        <td role="cell" data-label="APRC">
          <Typography
            variant="body1"
            component="span"
            className="content"
            fontSize={{
              md: '14px !important',
              xs: '12px !important',
            }}
          >
            APRC <br />
            {product.AprLenders}%
            <br />
            Arrangement Fee
            <br />£
            {product.ArrangementFee.toLocaleString('en-GB', {
              minimumFractionDigits: 2,
            })}
          </Typography>
        </td>
        <td role="cell" data-label="Enquire">
          <Stack direction="column" spacing={2}>
            <Typography
              variant="body1"
              component="span"
              className="learn-more"
              fontSize={{
                md: '14px !important',
                xs: '12px !important',
              }}
            ></Typography>
            <Box className="content learn-more">
              <Button
                variant="contained"
                color="secondary"
                href={
                  //@ts-ignore
                  theme?.custom?.appConfig?.enquireButtonLink ??
                  //@ts-ignore
                  theme?.custom?.links?.enquireButtonLink
                }
                target="_self"
                disableRipple
                disableElevation
                sx={{
                  mb: '0 !important',
                  borderRadius: '20px',
                  color: 'white',
                  border: `1px solid ${theme?.palette?.primary?.main}`,
                  '&:hover': {
                    border: `1px solid ${theme?.palette?.secondary?.main} !important`,
                    borderColor: `${theme?.palette?.secondary?.main} !important`,
                    background: 'transparent',
                    '& .button-text': {
                      color: `${theme?.palette?.secondary?.main} !important`,
                    },
                  },
                }}
              >
                <Typography
                  className="button-text"
                  variant="body1"
                  component="span"
                  textTransform="capitalize"
                  fontSize={{
                    md: '14px !important',
                    xs: '12px !important',
                  }}
                  sx={{
                    color: `white !important`,
                    '&:hover': {
                      color: `${theme?.palette?.secondary?.main} !important`,
                    },
                  }}
                >
                  Enquire
                </Typography>
              </Button>
              <Button
                variant="text"
                // color="primary"
                onClick={handleToggle}
                endIcon={isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                disableRipple
                sx={{
                  mb: '0 !important',
                  borderRadius: '20px',
                }}
              >
                <Typography
                  // color="primary"
                  variant="body1"
                  component="span"
                  textTransform="capitalize"
                  fontSize={{
                    md: '14px !important',
                    xs: '12px !important',
                  }}
                >
                  More Info
                </Typography>
              </Button>
            </Box>
          </Stack>
        </td>
      </tr>
      <tr role="row" className={`fold ${isOpen ? 'open' : ''}`}>
        <td role="cell" colSpan={isMatchDownMd ? 1 : 7}>
          <Box
            className="product-item-info"
            margin="0.5rem 1rem"
            display="flex"
            flexDirection="column"
            padding="10px"
            flex={1}
            sx={{
              // height: (isOpen ? (isMatchDownMd ? 640 : 400) : 0) + 'px',
              overflow: 'hidden',
              transition: `height 0.3 ease-out`,
              bgcolor: 'primary.main',
            }}
          >
            <ProductItemInfo product={product} />
          </Box>
        </td>
      </tr>
    </>
  )
}

export default ProductItem
